import Validation from "utils/validation.utils";
import locale from "localization";
import { formatAmount, parseNumber } from "utils";

export const createAmountValidations = ({
  minimumCashin = 10000,
  maxAmount = 500000,
  dailyRemainingLimit = null,
  weeklyRemainingLimit = null,
  monthlyRemainingLimit = null,
}) => {
  const toNullableNumber = (value) => {
    if (value == null) {
      return null;
    }

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  };

  const limits = [
    {
      remaining: toNullableNumber(dailyRemainingLimit),
      message: locale.yourRemainingDailyLimitIs,
    },
    {
      remaining: toNullableNumber(weeklyRemainingLimit),
      message: locale.yourRemainingWeeklyLimitIs,
    },
    {
      remaining: toNullableNumber(monthlyRemainingLimit),
      message: locale.yourRemainingMonthlyLimitIs,
    },
  ];

  const validateRemainingLimit = (field) => {
    const rawValue = field?.value?.toString().trim();
    if (!rawValue) {
      return { error: false, message: "" };
    }

    const amount = Number(parseNumber(field.value));
    if (!Number.isFinite(amount) || amount <= 0) {
      return { error: false, message: "" };
    }

    const validLimits = limits.filter((item) => {
      return item.remaining != null;
    });

    const lowestLimit = validLimits.reduce((lowest, current) => {
      if (!lowest || current.remaining < lowest.remaining) {
        return current;
      }
      return lowest;
    }, null);

    const exceededLimit =
      lowestLimit && amount > lowestLimit.remaining
        ? lowestLimit
        : null;

    if (!exceededLimit) {
      return { error: false, message: "" };
    }

    if (exceededLimit.remaining <= 0) {
      return {
        error: true,
        message: locale.yourCashInLimitHasBeenReached,
      };
    }

    return {
      error: true,
      message: locale.populate(exceededLimit.message, [formatAmount(exceededLimit.remaining)]),
    };
  };

  return [
    Validation.required(),
    Validation.min(minimumCashin, {
      customMessage: locale.populate(locale.minimumCashInIsAmount, [formatAmount(minimumCashin)]),
      isFormatted: true,
    }),
    Validation.max(maxAmount, {
      customMessage: locale.populate(locale.maximumAmountSelectedBank, [formatAmount(maxAmount, "")]),
      isFormatted: true,
    }),
    validateRemainingLimit,
  ];
};

export const initialState = (
  state = {},
  {
    minimumCashin = 10000,
    dailyRemainingLimit = null,
    weeklyRemainingLimit = null,
    monthlyRemainingLimit = null,
  } = {}
) => {
  const {
    bankCode = {
      value: "",
      name: "bankCode",
      validations: [Validation.required()],
      required: true,
      method: "",
    },
    method = {
      value: "",
      name: "method",
      validations: [Validation.required()],
      required: true,
    },
    processor = {
      value: "",
      name: "processor",
      validations: [Validation.required()],
      required: true,
    },
    amount = {
      value: "",
      name: "amount",
      validations: createAmountValidations({
        minimumCashin,
        maxAmount: 500000,
        dailyRemainingLimit,
        weeklyRemainingLimit,
        monthlyRemainingLimit,
      }),
      required: true,
    },
  } = state;
  return {
    bankCode,
    amount,
    method,
    processor,
  };
};
